export enum ProductFile {
    TopPrisma = '/resource/product/offers/topprisma/file',
    PaybackConfig = '/resource/payback/config'
}
